import dynamic from "next/dynamic";
import DynamicHeaderConfig from "./dynamic-header-config";
import DynamicHeaderAdvancedConfig from "./dynamic-header-advanced-config";
const DynamicHeaderComponent = dynamic(()=>import("./dynamic-header-component"));
export default {
    DynamicHeaderComponent,
    DynamicHeaderConfig,
    DynamicHeaderAdvancedConfig
};
